import animations from './animations.json'
import { drawImage } from './images.js'

/**
 * Wrapper for Aseprite JSON export format.
 */
class Animation {
    constructor(name) {
        this.animation = animations.filter(f => f.name === name)[0]
        this.frames = this.animation.frames
        this.meta = this.animation.meta

        this.frameNumber = 0
        this.elapsed = 0
        this.frameElapsed = 0
        this.direction = 1

        this.listeners = {
            frame: {},
            ended: () => {},
        }
    }

    AddListener(type, frameNumber, callback) {
        this.listeners[type][frameNumber] = callback
    }
    
    HasListener(type, frameNumber) {
        return this.listeners[type][frameNumber] ? true : false
    }

    CallListener(type, frameNumber) {
        if (this.HasListener(type, frameNumber)) {
            this.listeners[type][frameNumber](this)
        }
    }
    
    ClearListener(type, frameNumber) {
        if (this.HasListener(type, frameNumber)) {
            this.listeners[type][frameNumber] = undefined
            delete this.listeners[type][frameNumber]
        }
    }

    Play() {
        this.direction = 1
    }

    PlayFromStart() {
        this.frameNumber = 0
        this.frameElapsed = 0
        this.direction = 1
        this.elapsed = 0
    }

    Pause() {
        this.direction = 0
    }

    FrameId(frameNumber) {
        let frameId = Object.keys(this.frames)[frameNumber]
        return frameId
    }

    Frame(frameNumber) {
        return this.frames[this.FrameId(frameNumber)]
    }

    CurrentFrameId() {
        return this.FrameId(this.frameNumber)
    }

    CurrentFrame() {
        return this.Frame(this.frameNumber)
    }

    FrameMetaTag(frameNumber) {
        let tag = this.meta.frameTags.filter(f => frameNumber >= f.from && frameNumber <= f.to)
        return tag.length > 0 ? tag[0] : null
    }

    MetaTag(frameTag) {
        return this.meta.frameTags.filter(f => f.name === frameTag)
    }

    Update(delta) {
        this.frameElapsed += delta * this.direction
        this.elapsed += delta * Math.abs(this.direction)
        let frame = this.CurrentFrame()
        let frameTag = this.FrameMetaTag(this.frameNumber)
        try {
            if (this.direction > 0 && this.frameElapsed >= frame.duration && frameTag.direction === 'forward') {
                this.frameNumber += this.direction
                this.frameElapsed = 0
            }
            
            if (this.frameNumber === Object.keys(this.frames).length - 1) {
                this.listeners.ended(this)
            }

            if (this.direction > 0 && this.frameElapsed >= frame.duration
            && frameTag.direction === 'pingpong' && frameTag.to === this.frameNumber) {
                this.direction = this.direction * -1
                this.frameNumber += this.direction
                this.frameElapsed = frame.duration
            } else if (this.direction > 0 && this.frameElapsed >= frame.duration
            && frameTag.direction === 'pingpong' && frameTag.to > this.frameNumber) {
                this.frameNumber += this.direction
                this.frameElapsed = 0
            }
            
            if (this.direction < 0 && this.frameElapsed <= 0
            && frameTag.direction === 'pingpong'
            && frameTag.from === this.frameNumber) {
                this.direction = this.direction * -1
                this.frameElapsed = 0
            } else if (this.direction < 0 && this.frameElapsed <= 0
            && frameTag.direction === 'pingpong'
            && frameTag.from < this.frameNumber) {
                this.frameNumber += this.direction
                this.frameElapsed = 0
            }

            if (this.HasListener('frame', this.frameNumber)) {
                this.CallListener('frame', this.frameNumber)
            }
        } catch (err) {
            console.log(err)
        }
    }

    Draw(x, y) {
        let frame = this.CurrentFrame()
        drawImage(this.meta.image, x, y, { x: frame.frame.x, y: frame.frame.y, w: frame.frame.w, h: frame.frame.h })
    }
}

export default Animation